import Vue from "vue";
import VueQuillEditor from "vue-quill-editor";

Vue.use(VueQuillEditor);
